import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { ApplicationCase } from '../../models/api/application-case.model';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';
import { CaseRequestsService } from '../../services/case-requests.service';

@Component({
  selector: 'boi-case-requests',
  templateUrl: './case-requests.component.html',
  styleUrls: ['./case-requests.component.scss']
})
export class CaseRequestsComponent implements OnChanges {
  @Input() public applicationCase: ApplicationCase;
  @Output() public readonly goToCustomersTab = new EventEmitter();
  @Output() public readonly goToAgentDetails = new EventEmitter<string>();

  public caseRequests$: Observable<Array<CaseRequestDto>>;

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;

  constructor(private readonly caseRequestsService: CaseRequestsService) {}

  ngOnChanges(): void {
    this.caseRequests$ = this.caseRequestsService.getCaseRequests(this.applicationCase.CaseNumberAsHash);
  }
}
